import React from "react";
import ReactPlayer from "react-player";
import ImageSkeleton from "../components/ImageSkeleton";

const Player = ({ url, ...rest }) => {
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    setIsLoading(true);
  }, [url]);

  const handleReady = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false);
  };

  return (
    <>
      {isLoading && <ImageSkeleton type="video" />}
      <ReactPlayer
        id="react-player"
        url={url}
        playing={false}
        controls={true}
        onReady={handleReady}
        onError={handleError}
        style={{ display: isLoading ? "none" : "block" }}
        {...rest}
      />
    </>
  );
};

export default React.memo(Player);
